/**
 * Concatène des classes CSS en ignorant ce qui est absent.
 *
 * Les modules CSS sont typés `Record<string, string>` et le projet compile avec
 * `noUncheckedIndexedAccess` : chaque accès vaut donc `string | undefined`.
 * Passer par ce helper évite d'écrire `?? ''` à chaque classe.
 */
export function cx(...parts: readonly (string | false | null | undefined)[]): string {
  return parts.filter((part): part is string => typeof part === 'string' && part !== '').join(' ');
}
